"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var mobx_react_1 = require("mobx-react");
var form_1 = __importDefault(require("~/components/forms/blog_comment_form/form"));
var blog_comment_form_store_1 = __importStar(require("~/stores/forms/blog_comment_form_store"));
var mobx_1 = require("mobx");
var BlogCommentForm = /** @class */ (function (_super) {
    __extends(BlogCommentForm, _super);
    function BlogCommentForm(props) {
        var _this = _super.call(this, props) || this;
        _this.isModalOpen = false;
        _this.handleClickSubmitButton = function () {
            _this.store.submitComment().then(function () {
                _this.isModalOpen = false;
            });
        };
        _this.store = new blog_comment_form_store_1.default(props);
        return _this;
    }
    BlogCommentForm.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_responsive_modal_1.default, { open: this.isModalOpen, onClose: function () { _this.isModalOpen = false; }, classNames: { modal: 'blogComment-ModalContainer' } },
                react_1.default.createElement(form_1.default, { store: this.store, onClickSubmitButton: this.handleClickSubmitButton })),
            react_1.default.createElement("div", { className: "blogComment-OpenModalButtonWrapper" },
                react_1.default.createElement("button", { className: "sw-Button sw-Button-cta", onClick: function () { _this.isModalOpen = true; } }, "\u30B3\u30E1\u30F3\u30C8\u3092\u6295\u7A3F\u3059\u308B"))));
    };
    var _a, _b;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof blog_comment_form_store_1.default !== "undefined" && blog_comment_form_store_1.default) === "function" ? _a : Object)
    ], BlogCommentForm.prototype, "store", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BlogCommentForm.prototype, "isModalOpen", void 0);
    BlogCommentForm = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [typeof (_b = typeof blog_comment_form_store_1.Props !== "undefined" && blog_comment_form_store_1.Props) === "function" ? _b : Object])
    ], BlogCommentForm);
    return BlogCommentForm;
}(react_1.default.PureComponent));
exports.default = BlogCommentForm;
